module.exports = __webpack_public_path__ + "media/images/universe_landing_pages/hero_banner/component/cleaning-desktop@3x-e351f48b2a763d6d3c44569bf8bc086b.jpg";